import { getCdiDataService } from '../services'

export default (registerId) => {
  return new Promise(async (resolve, reject) => {
    await getCdiDataService.getCdi(registerId)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
